<template>
  <v-container fluid class="creativeproject-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12" centered>
        <v-tabs
          color="primary"
        >
          <v-tabs-slider></v-tabs-slider>
          <v-tab
            :href="`#tab-project`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-account-edit</v-icon>
            Finalize
          </v-tab>
          <v-tab-item
            :value="'tab-project'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="5">
                    <v-form>
                      <p class="text-h5">Finalize Project</p>
                      <v-select
                        class="mb-4"
                        :items="['Finalize']"
                        v-model="update_project.projectstatus"
                        v-bind:error="errorindex == 0"
                        outlined
                        dense
                        placeholder="Status"
                        persistent-hint
                        single-line hint="Please choose the status">
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items=projectnotes[update_project.projectstatus]
                        v-model="update_project.projectnote"
                        v-bind:error="errorindex == 1"
                        outlined
                        dense
                        placeholder="Note"
                        persistent-hint
                        single-line hint="Please choose the note">
                      </v-select>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="5">
                    <div class="d-flex justify-center">
                        <v-btn
                            to="/creativeproject/team/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="updateCreativeProject()">
                            Save
                          </v-btn>
                      </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
    <v-row>


    </v-row>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      error: undefined,
      errortag: false,
      errorindex: undefined,

      initvalue: {},
      update_project: {},
      projectnotes: {
        "Finalize":  [
          'Project has been marked as Completed by the System',
        ],
      },
    }
  },
  computed: {
    ...mapState('CreativeProject', ['isReceiving']),
  },
  methods: {
    ...mapActions('CreativeProject', [ 'getCreativeProjectsRequest','updateCreativeProjectFinalizeRequest']),
    checkError(){
      if(!this.update_project.projectstatus){
        this.errortag = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.update_project.projectnote){
        this.errortag = true;
        this.errorindex = 1;
        return false;
      }

      this.errorindex = -1;
      return true;
    },
    async updateCreativeProject() {
      if(!this.checkError()) return;
      this.update_project._id = this.initvalue._id;
      await this.updateCreativeProjectFinalizeRequest(this.update_project);
      router.push('/creativeproject/team/list');
    },
  },

  async created () {
    this.initvalue = this.$route.params;
    if(!this.initvalue._id) this.$router.push({ name: 'CreativeProjectTeamList' });
  },
}
</script>

<style src="./Edit.scss" lang="scss"></style>
